import React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import HtmlListWithDisclosures from '../../../common/HtmlListWithDisclosures';

const StandardFeatures = ({ styleId, styles, disclosures }) => {
  const style = find(styles, { styleId });
  const marketingCopy = style?.marketingCopy;

  return (
    <>
      {marketingCopy && (
        <div className="card-features__container">
          <HtmlListWithDisclosures
            className="card-features__features"
            content={marketingCopy}
            disclosures={disclosures}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { config, disclosures } = state;
  const { styles } = config;

  return {
    disclosures,
    styles,
  };
};

export default connect(mapStateToProps)(StandardFeatures);
